import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/base/SectionTitle';
import { topicCollections } from '@/mocks/movies';
import { typeLabel } from '@/utils/media';

const accents = [
  'bg-primary-500 text-background-50',
  'bg-accent-500 text-accent-950',
  'bg-secondary-500 text-background-50',
  'bg-primary-950 text-background-50',
];

export default function TopicSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <SectionTitle icon="ri-stack-line" title={t('topicCollection')} desc={t('featuredDesc')} />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {topicCollections.map((topic, i) => (
            <Link
              key={topic.id}
              to={`/category/${topic.type}`}
              className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-accent-300 cursor-pointer"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${accents[i % accents.length]}`}>
                <i className="ri-folder-3-line text-xl"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-accent-600 transition">
                  {topic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{topic.desc}</p>
              </div>
              <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                  {typeLabel(topic.type)}
                </span>
                <span className="flex items-center gap-1 group-hover:gap-2 transition-all">
                  {topic.count} {t('itemCount')}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}